<template>
  <BaseSimpleLayout class="master-sub-category-list">
    <template #title>分類マスタ一覧</template>
    <template #button-area>
      <el-input
        v-model="searchText"
        size="large"
        placeholder="検索"
        @input="searchData"
      />
      <ScreenPermissionGate code="SUB_CATEGORY-BTN_CREATE">
        <el-button
          type="success"
          size="large"
          @click="router.push('/master/subCategory/create')"
        >
          分類登録
        </el-button>
      </ScreenPermissionGate>
    </template>
    <template #main>
      <el-table :data="tableData" border :max-height="tableHeight">
        <el-table-column
          prop="id"
          label="ID"
          width="80"
          align="center"
          sortable
        />
        <el-table-column prop="name" label="名前" width="550" sortable>
          <template #default="scope">
            <a href="#" @click="moveDetail(scope.row.id)">{{
              scope.row.name
            }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="categoryName" label="カテゴリー名称" sortable />
      </el-table>
    </template>
  </BaseSimpleLayout>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { useStore } from 'vuex';
  import router from '@/router';
  import BaseSimpleLayout from '@/components/BaseSimpleLayout.vue';
  import { SubCategoriesDataState } from '@/types/master/subCategory';
  import { ElLoading } from 'element-plus';
  import ScreenPermissionGate from '@/components/ScreenPermissionGate.vue';

  const store = useStore();
  const tableData = ref<SubCategoriesDataState[]>([]);
  const loadingFlag = ref(false);
  const tableHeight = ref(600);
  const searchText = ref('');

  const initialize = async () => {
    const loadingInstance = ElLoading.service({ fullscreen: true });
    await Promise.all([store.dispatch('subCategoriesMaster/fetch')]);
    tableData.value = store.state.subCategoriesMaster.listData;
    tableHeight.value = window.innerHeight - 120;
    loadingInstance.close();
    loadingFlag.value = true;
  };
  const moveDetail = (id: number) => {
    router.push('/master/subCategory/' + id);
  };
  const searchData = () => {
    tableData.value = store.state.subCategoriesMaster.listData.filter(
      (subCategory: SubCategoriesDataState) => {
        return (
          subCategory.name.includes(searchText.value) ||
          subCategory.categoryName.includes(searchText.value)
        );
      }
    );
  };
  initialize();
</script>
<style lang="scss">
  .master-sub-category-list {
    .el-input {
      width: 300px;
      margin: 0 20px;
    }
    .el-table {
      margin: 10px 0 0;
      thead th {
        background: #f5f7fa;
      }
    }
    .el-button {
      font-weight: 600;
    }
  }
</style>
